import React from 'react';
import { List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export const WorkersTable = ({ workers }) => {
  const workersTableRows = workers
    .map(({ name, id }) => (
      <List.Item key={name}>
        <List.Content style={styles.listContent}>
          <List.Header
            as={Link}
            to={`/workers/${id}`}
            content={name}
          />
        </List.Content>
      </List.Item>
    ));

  if (!workers.length) {
    return (
      <p style={styles.noAssignedItems}>No workers assigned yet</p>
    );
  }

  return (
    <List>
      { workersTableRows }
    </List>
  );
}

const styles = {
  listContent: {
    padding: 0,
  },
  noAssignedItems: {
    textAlign: 'center',
    padding: '20px 0',
  },
};
